import {Component, Inject, Input, OnInit, Optional, Renderer2} from '@angular/core';
import {NgxSmartModalService} from "ngx-smart-modal";
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {ScriptService} from "../../../services/script.service";
import {DOCUMENT} from "@angular/common";
import {LANG} from "../../../tokens/lang.token";
import {LanguageService} from "../../../services/language.service";

@Component({
  selector: 'synapi-item-modal-sncf',
  standalone: true,
  imports: [],
  templateUrl: './synapi-item-modal-sncf.component.html',
  styleUrl: './synapi-item-modal-sncf.component.scss'
})
export class SynapiItemModalSncfComponent implements OnInit{
  @Input() item : SynapiItem;
  constructor(public langService: LanguageService, public scriptService: ScriptService, private renderer: Renderer2,@Inject(DOCUMENT) private document: Document){
    this.document.addEventListener(
      "IvtsWidgetsExternal.Booking.Ready",
      // @ts-ignore
      ({ detail: bookingWidget }) => {
        // @ts-ignore
        window.sncfWidget = bookingWidget;
      }
    );
  }
  ngOnInit() {
    const scriptElement = this.scriptService.loadJsScript(this.renderer,'https://www.sncf-connect.com/widget-external/web-widgets-external.js')
    scriptElement.onload = ()=> {
      const ficheSncfContainer = document.getElementById('FicheSncfContainer');
      const ficheSncfWidget = document.getElementById('FicheSncfWidget');
      if (ficheSncfWidget) {
        ficheSncfWidget.remove();
      }
      if (ficheSncfContainer){
        const innerDiv = document.createElement('div');
        innerDiv.id = 'FicheSncfWidget';
        ficheSncfContainer.appendChild(innerDiv);
      }
      // @ts-ignore
      window.sncfWidget.init("FicheSncfWidget", {
        titleIndex: 0,
        destination: { defaultValue: this.item.AdressePrincipale?.Commune },
        tracking: {
          wizalyQueryParameters:
            "wiz_medium=part&wiz_source=visitvar&wiz_campaign=fr_conv_Widget_contenu_filrouge_tr-multiproduit__mk_202402&wiz_content=_fr_cpa",
        },
      }, this.langService.current == 'fr'? undefined: 'en-en');
    }
  }
}
